import {
  Dropdown,
  PaginatedDropdownList,
  UsersListListData,
  usersListListInfiniteOptions
} from '@crm/api'
import { InfiniteSelect } from '@crm/components'
import { FormColorPicker } from '@shared/components'
import { useLocales } from '@shared/locales'
import { Checkbox, Form, Input } from 'antd'
import { FormInstance } from 'antd/lib'

type Props = {
  form?: FormInstance
}

export const FormNomenclaturesLeadTypes = ({ form }: Props) => {
  const { t } = useLocales()

  const responsible = Form.useWatch('responsible', form)

  return (
    <>
      <Form.Item
        name="name"
        label={t('nomenclature.name')}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="code"
        label={t('nomenclature.code')}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>

      <FormColorPicker
        itemProps={{
          label: t('nomenclature.color')
        }}
        showText
      />

      <Form.Item name="order" label={t('nomenclature.order')}>
        <Input type="number" />
      </Form.Item>

      <Form.Item name="responsible" label={t('nomenclature.responsible')}>
        <InfiniteSelect<UsersListListData, PaginatedDropdownList, Dropdown>
          popupMatchSelectWidth
          placeholder={t('main.select')}
          getQueryFunction={usersListListInfiniteOptions}
          baseOptions={{
            query: {
              preference: responsible
            }
          }}
        />
      </Form.Item>

      <Form.Item
        name="is_default"
        label={t('nomenclature.is_default')}
        valuePropName="checked"
        initialValue={false}
      >
        <Checkbox />
      </Form.Item>
    </>
  )
}
